import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        link: {
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(0.5),
        },
        updateformGridCardWrapper: {
            gridTemplateColumns: 'repeat(3, 1fr) !important',
            '& .typeahead-options-wrapper': {
                position: 'fixed',
            },
        },
    }
})

export default useStyles
